import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { Container, ProgressBar } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
const Loader = () => {
  const language = useSelector((state) => state.language.language);

  return (
    <>
      <div
        style={{
          height: "100vh",
          zIndex: "9999",
          backgroundColor: "#fff",
          position: "relative",
        }}
        className="d-flex align-items-center "
      >
        <div className="container mt-5 text-center">
          {" "}
          <div
            className="loader d-flex justify-content-center align-items-center"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ zIndex: "9999999", position: "fixed" }}>
              <LazyLoadImage
                effect="blur"
                alt="loader"
                src={
                  language === "ru"
                    ? "Spin-ru.gif"
                    : language === "de"
                    ? "Spin-de.gif"
                    : "Spin.gif"
                }
                width="100"
                // style={{ filter: "hue-rotate(185deg)" }}
                style={{ filter: "brightness(0.7)" }}
              />
              {/*<p className="fs-5 mt-3">Loading...</p> */}
            </div>
          </div>
          {/* <ProgressBar
            animated
            now={now}
            label={`${now}%`}
            style={{ height: "2px", color: "#000" }}  />{" "}*/}
        </div>
      </div>
    </>
  );
};

export default Loader;
